import React from 'react';
import SectionTitle from '../../elements/section-title/SectionTitle';

const Datas = [
    {
      id: 1,
      title: "Results, not buzzwords",
      para: "We focus on measurable outcomes saving time, reducing costs, improving operations, or increasing revenue. Every project starts with clear KPIs, scope, and success criteria."
    },
    {
      id: 2,
      title: "Security & privacy by design",
      para: "We build with secure architecture from day one: least-privilege access, encryption where needed, audit trails, and privacy first workflows to protect your business and users."
    },
    {
      id: 3,
      title: "Fast delivery, built to scale",
      para: "We ship MVPs quickly, then harden and scale them. Clean code, DevOps, monitoring, and performance optimization are part of our delivery not afterthoughts."
    },
    {
      id: 4,
      title: "Transparent partnership",
      para: "You get honest timelines, clear pricing, and regular updates. No surprises just visibility into what’s done, what’s next, and the decisions we need from you."
    },
    {
      id: 5,
      title: "Responsible AI that delivers value",
      para: "We use AI where it truly helps automation, support, analytics, and personalization while keeping humans in control, reducing hallucinations, and ensuring reliable outputs."
    }
  ];



const AboutThree = () => {
    return (
        <div className="section section-padding bg-color-dark pb--80 pb_lg--40 pb_md--20" id='our_values'> 
            <div className="container">
                <SectionTitle 
                    subtitle="Our Values"
                    title="Why should you work with us?"
                    description="We don’t just build software , we build reliable systems that grow with your business."
                    textAlignment="heading-left heading-light-left mb--100"
                    textColor=""
                />

                <div className="row">
                    {Datas.map((data) => (
                        <div className="col-lg-4" key={data.id}>
                            <div className="about-quality">
                                <h3 className="sl-number">{data.id}</h3>
                                <h5 className="title">{data.title}</h5>
                                <p>{data.para}</p>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
            <ul className="list-unstyled shape-group-10">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-1.png"} alt="Circle" /></li>
                <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/line-3.png"} alt="Circle" /></li>
                <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-5.png"} alt="Circle" /></li>
            </ul>
        </div>
    )
}

export default AboutThree;